
const AlertMessage = (props: any) => {
  let description = props.description ?? "";
  let additionalClass = props.additionalClass || "";

  return (
    <div className={`BoxAlertMessage ${additionalClass}`}>
      <div className="row">
        <div className="col-auto">
          <span className="material-icons">
            warning
          </span>
        </div>
        <div className="col p-0">
          <p>{description}</p>
        </div>
      </div>
    </div>

  )

}

export default AlertMessage;